import { getTemplateRatio } from "~/common/videoTemplate/template"
import { useState } from "react"
import { Button } from "antd"
import classNames from "classnames"
import { VideoPlayer, VideoDownloadPolicy } from "~/components/VideoPlayer"
import type { VideoTemplate } from "~/common/videoTemplate"
import styles from "./index.css"

export const TemplateVideo = ({
  card,
  className,
}: {
  card: VideoTemplate
  className?: string
}) => {
  const [failed, setFailed] = useState(false)
  const [attempt, setAttempt] = useState(0)
  const aspectRatio = getTemplateRatio(card).replace(":", " / ")
  if (!card.videoUrl)
    return (
      <div
        className={classNames(styles.placeholder, className)}
        style={{ aspectRatio }}
      >
        案例视频即将上线
      </div>
    )
  return (
    <div className={classNames(styles.player, className)}>
      <VideoDownloadPolicy value={true}>
        <VideoPlayer
          key={attempt}
          className={styles.video}
          controls
          playsInline
          autoPlay
          muted
          poster={card.videoCover}
          src={card.videoUrl}
          style={{ aspectRatio }}
          onError={() => setFailed(true)}
        />
      </VideoDownloadPolicy>
      {failed ? (
        // VideoPlayer 自身会展示失败文案，这里只补充重新加载入口
        <Button
          className={styles.retry}
          onClick={() => {
            setFailed(false)
            setAttempt((value) => value + 1)
          }}
        >
          重新加载
        </Button>
      ) : null}
    </div>
  )
}
